import { OperationVariables, useApolloClient } from '@apollo/client';
import { useCuriosityTranslationLoader } from '@procureai/curiosity-ui-mui';
import { useCustomSnackbar } from '@procureai/ui-mui';
import { useState } from 'react';

import {
  UseDataGridExportLocalProps,
  UseDataGridExportProps,
  UseDataGridExportResult,
} from './useDataGridExport.types';
import { exportGridData } from './useDataGridExport.util';

export const useDataGridExport = <TData = any, TVariables extends OperationVariables = OperationVariables>({
  apiRef,
  query,
  variables,
  getNodes,
  config,
}: UseDataGridExportProps<TData, TVariables>): UseDataGridExportResult => {
  const client = useApolloClient();
  const [loading, setLoading] = useState(false);
  const { onError } = useCustomSnackbar();
  const curiosityLoader = useCuriosityTranslationLoader();

  const exportStart = async () => {
    setLoading(true);
    try {
      const { data } = await client.query<TData, TVariables>({
        query,
        fetchPolicy: 'network-only',
        variables: {
          ...variables,
          skipExport: true,
          limit: 1000,
          offset: 0,
        } as any,
      });
      if (data) {
        const nodes = getNodes(data);
        await exportGridData({
          data: nodes || [],
          config,
          fileName: 'export',
          curiosityLoader,
          apiRef,
        });
      }
    } catch (e) {
      onError(e);
    }
    setLoading(false);
  };

  return {
    exporting: loading,
    exportStart,
  };
};

export const useDataGridExportLocal = ({
  data,
  config,
  apiRef,
}: UseDataGridExportLocalProps): UseDataGridExportResult => {
  const [loading, setLoading] = useState(false);
  const { onError } = useCustomSnackbar();
  const curiosityLoader = useCuriosityTranslationLoader();

  const exportStart = async () => {
    setLoading(true);
    try {
      if (data) {
        await exportGridData({
          data,
          config,
          fileName: 'export',
          curiosityLoader,
          apiRef,
        });
      }
    } catch (e) {
      onError(e);
    }
    setLoading(false);
  };

  return {
    exporting: loading,
    exportStart,
  };
};
